import React, {useMemo, useState} from 'react'
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import {isDemandModification, isDemandOfferCollection, wasEverPublished} from "libs/getDemandStatus";
import downloadFile from "libs/downloadFile";
import ChooseSwzGeneratorOptions from "components/complex/papersGenerator/customPopups/swzGenerator/ChooseSwzGeneratorOptions";
import isBzpAttachmentNoticeType from "libs/isBzpAttachmentNoticeType";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import AddBzpNoticePopup from "./AddBzpNoticePopup";
import SelectSiwzDocument from "./SelectSiwzDocument";
import PropTypes from "prop-types";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import Endpoints from "constants/Endpoints";
import {makeStyles} from "@material-ui/core";

const useStyle = makeStyles(theme => ({
    topButtons: {
        marginBottom: theme.spacing(1)
    }
}));

function SiwzDocuments(
    {
        demandId,
        editable,
        demandHeader
    }) {

    const classes = useStyle();
    const [addBzpNoticePopupOpened, setAddBzpNoticePopupOpened] = useState(false);
    const [swzParamsOpen, setSwzParamsOpen] = useState(false);

    const isBzpAttachmentNotice = useMemo(() => isBzpAttachmentNoticeType(demandHeader), [demandHeader]);
    const isPublished = useMemo(() => demandHeader ? wasEverPublished() : undefined, [demandHeader]);
    const isOfferCollectionOrModification = useMemo(() => demandHeader ? isDemandOfferCollection() || isDemandModification() : undefined, [demandHeader]);

    const getButtons = () => {
        const buttons = [];
        if (isBzpAttachmentNotice && editable && (!isPublished || isOfferCollectionOrModification)) {
            buttons.push(createButton(Tr(isPublished ? "add_bzp_notice_update" : "add_bzp_notice"), () => setAddBzpNoticePopupOpened(true)))
        }

        if (demandHeader && editable) {
            if(!isPublished || isOfferCollectionOrModification) {
                if (demandHeader.applicationClientSettings.papersGenerator.active) {
                    buttons.push(createButton(Tr('swz_button'), () => setSwzParamsOpen(true)))
                } else {
                    buttons.push(createButton(Tr('swz_button'), () => downloadFile({url: Endpoints.PAPERS_GENERATOR_PRINT(demandId, 'swz_generator')})))
                }
            }
        }

        if (buttons.length)
            return <MultiButton className={classes.topButtons} buttons={buttons} justify="flex-start"/>
    }

    return (
        <GridBlock
            column
        >
            {getButtons()}

            <SelectSiwzDocument
                demandId={demandId}
                disabled={!editable}
                isPublished={isPublished}
            />

            {addBzpNoticePopupOpened && <AddBzpNoticePopup demandId={demandId} onClose={() => setAddBzpNoticePopupOpened(false)}/>}
            {swzParamsOpen && <ChooseSwzGeneratorOptions id={demandId} onClose={() => setSwzParamsOpen(false)}/>}

        </GridBlock>
    )
}

SiwzDocuments.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    editable: PropTypes.bool
};

export default connect((state) => ({
    demandHeader: state.resources.demandHeader
}), {})(withRouter(SiwzDocuments));